import { useState, useEffect } from "react";
import { Tab, Segment, Header, Icon } from "semantic-ui-react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { StrategyObjectivesMatrix } from "../../../components/Admin/Matrix/StrategyObjectivesMatrix";
import { WasteBaselineModule } from "../../../components/Admin/Matrix/WasteBaselineModule";
import { useLanguage, useSite } from "../../../contexts";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import "./Matrices.scss";

const permissionController = new Permission();

export function Matrices() {
  const { translations } = useLanguage();
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const t = (key) => translations[key] || key;
  const [siteSelected, setSiteSelected] = useState(null);
  const [permissionsByRole, setPermissionsByRole] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const { site } = useSite();

  useEffect(() => {
    (async () => {
      setSiteSelected(site);
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "matrices", "view")
  ) {
    const panes = [
      {
        menuItem: {
          key: "objectives",
          icon: "target",
          content: t("strategy_objectives_matrix") || "Matriz de Objetivos",
        },
        render: () => (
          <Tab.Pane attached={false}>
            <StrategyObjectivesMatrix site={siteSelected} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: {
          key: "waste-baseline",
          icon: "recycle",
          content: t("waste_baseline") || "Línea Base Residuos",
        },
        render: () => (
          <Tab.Pane attached={false}>
            <WasteBaselineModule site={siteSelected} />
          </Tab.Pane>
        ),
      },
    ];

    const getTitle = () => {
      if (activeTab === 0) {
        return t("strategy_objectives_monitoring_matrix") || "Matriz de Seguimiento de Objetivos Estratégicos";
      }
      return t("waste_baseline_title") || "Línea Base de Métodos de Disposición de Residuos";
    };

    return (
      <div className="matrices-page">
        <Segment
          textAlign="center"
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
          }}
        >
          <Header as="h1">
            <Icon name={activeTab === 0 ? "target" : "recycle"} />
            {getTitle()}
          </Header>
        </Segment>
        <Segment className="dashboard-segment">
          <Tab
            panes={panes}
            activeIndex={activeTab}
            onTabChange={(_, { activeIndex }) => setActiveTab(activeIndex)}
            menu={{ secondary: true, pointing: true }}
          />
        </Segment>
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
